module.exports = __webpack_public_path__ + "img/informacionrda.54fae865.jpg";